export const addressFormRequiredConstraints = {
    state: ({ countryCode }: { countryCode: string}) => {
        return ["au","br","ca","gb","us"].includes(countryCode.toLowerCase());
    },
    cpfNumber: ({ countryCode }: { countryCode: string }) => {
        return countryCode.toLowerCase() === "br";
    },
    rfcNumber: ({ countryCode }: { countryCode: string }) => {
        return countryCode.toLowerCase() === "mx";
    }
} as const;

export const validCpfRegex = new RegExp(/^\d{11}$/); // 11 digits, only numbers

// RFC format: 3-4 uppercase letters (A-Z, Ñ, &), followed by 6 digits, and a 3-character alphanumeric code
export const validRfcRegex = new RegExp(/^([A-ZÑ&]{3,4})\d{6}([A-Z\d]{3})$/);


